const colors = {
  navy: "#0B2C3D",
  green: "#1E7F43",
  lightGreen: "#46AF50",
  yellow: "#F4D03F",
  blue: "#377DB8",

  // neutrals
  bgSoft: "#F5F7FA",
  white: "#FFFFFF",
  textPrimary: "#1F2937",
  textSecondary: "#6B7280",

  // states
  success: "#46AF50",
  warning: "#F4D03F",
  danger: "#E74C3C",
  info: "#1677FF"
};

export default colors;
